import { Component, OnInit } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {Language} from '@app/core/constants/language';
import {AuthService} from '@app/core/auth/auth.service';
import {ModalCloseReason, ModalRef} from '@app/core/models/modal-ref';

let nextUniqueId = 0;

@Component({
  selector: 'app-modaldsgvo',
  templateUrl: './modaldsgvo.component.html',
  styleUrls: ['./modaldsgvo.component.scss']
})
export class ModaldsgvoComponent implements OnInit {
  public uniqueId = nextUniqueId++;

  public dsgvoText: SafeHtml = '';
  private dsgvoFile = './assets/html/terms-de.html'; // default DE
  public confirmed = null;

  constructor(private auth: AuthService,
              private modalRef: ModalRef,
              private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

    if (this.auth.getCurrentLanguage() !== Language.German) this.dsgvoFile = './assets/html/terms-en.html';

    fetch(this.dsgvoFile).then(res => res.text()).then(data => {
      this.dsgvoText = this.sanitizer.bypassSecurityTrustHtml(data);
    });

    // Close case
    this.modalRef.onWantsClose.subscribe(({reason, cancelClose, close}) => {

      if (reason === ModalCloseReason.Ok) {
        if (!this.verify()) {
          cancelClose();
        }
      } else {
        this.logout();
      }
    });

  }


  verify(): boolean {
    if (this.confirmed !== true) {
      this.confirmed = false;
    }
    return this.confirmed;
  }


  logout() {
    this.auth.logout();
  }
}
